<script setup lang="ts">
const { data: navigation } = await useAsyncData(
  'navigation',
  () => fetchContentNavigation(),
  { default: () => [] },
)

provide('navigation', navigation)

const updateHeight = () => {
  // Get the actual viewport height
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)

  // Get the actual header and footer heights
  const header = document.querySelector('header')
  const footer = document.querySelector('footer')
  if (header && footer) {
    const totalOffset = header.offsetHeight + footer.offsetHeight
    document.documentElement.style.setProperty('--offset', `${totalOffset}px`)
  }
}

onMounted(() => {
  updateHeight()
  window.addEventListener('resize', updateHeight)
  window.addEventListener('orientationchange', updateHeight)
})

onUnmounted(() => {
  window.removeEventListener('resize', updateHeight)
  window.removeEventListener('orientationchange', updateHeight)
})
</script>

<template>
  <div class="layout-container">
    <AppHeader />

    <UMain class="main-content">
      <slot />
    </UMain>

    <AppFooter />
  </div>
</template>

<style scoped>
.layout-container {
  min-height: 100vh; /* Fallback */
  min-height: calc(var(--vh, 1vh) * 100);
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1 0 auto;
  min-height: calc((var(--vh, 1vh) * 100) - var(--offset, 128px));
}
</style>
